import axios from 'axios'

function environment(){
  if (process.env.NODE_ENV === 'development') {
    return 'https://v2.ztys.com.cn'
  } else if (process.env.NODE_ENV === 'debug') {
    return 'https://v2.ztys.com.cn'
  } else if (process.env.NODE_ENV === 'production') {
    return'https://v2.ztys.com.cn'
  }
}

const service = axios.create({
  baseURL: environment(),
  headers: {
    "Content-Type": 'text/plain'
  }
})

service.interceptors.request.use(config => {
  config.data = {
    apikey: 123456,
    ...config.data
  }
  return config
}, error => {
  return Promise.reject(error);
})

service.interceptors.response.use(response => {
  // response = response.data
  return response;
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/http/http.js